module.exports = __webpack_public_path__ + "bl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bl.svg
// module id = 453
// module chunks = 0